import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const CheckedIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="1" y="1" width="18" height="18" rx="2" fill={fillColor || '#F6F6F7'} />
      <rect x="1" y="1" width="18" height="18" rx="2" stroke="#48484B" strokeWidth="2" />
      <path d="M5 9.11111L8.57143 13L15 6" stroke={fillColor || '#48484B'} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export { CheckedIcon };
